import Vue from 'vue';
import App from './App.vue';
import router from '@/router/router';
import store from '@/store/store';
import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import ptBR from 'vee-validate/dist/locale/pt_BR';
import VueI18n from 'vue-i18n';
import VueTheMask from 'vue-the-mask';
import money from 'v-money'
import Multiselect from 'vue-multiselect'
import VueMonthlyPicker from 'vue-monthly-picker'
import VueRouter from 'vue-router'
import VueUploadComponent from 'vue-upload-component'
import VueSuggestion from 'vue-suggestion'
import './filters/global'
import './plugins/axios'

Vue.use(VueTheMask);
Vue.use(money);
Vue.use(VueRouter);
Vue.use(VueSuggestion);

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'ptBR'
});

Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    ptBR
  }
});

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

  Vue.component('file-upload', VueUploadComponent)

  // register globally
  Vue.component('multiselect', Multiselect)
  Vue.component('vue-monthly-picker', VueMonthlyPicker)

  export default {
    // OR register locally
    components: { Multiselect },
    data () {
      return {
        value: null,
        options: ['list', 'of', 'options']
      }
    }
  }
